import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import type { RootState } from "../store";
import {
  setTheme,
  toggleTheme,
  initializeTheme,
  type ThemeMode,
} from "../store/reducers/themeSlice";

export const useTheme = () => {
  const dispatch = useDispatch();
  const mode = useSelector((state: RootState) => state.theme.mode);

  useEffect(() => {
    // Initialize theme on app load
    dispatch(initializeTheme());
  }, [dispatch]);

  const setThemeMode = (theme: ThemeMode) => {
    dispatch(setTheme(theme));
  };

  const toggleThemeMode = () => {
    dispatch(toggleTheme());
  };

  return {
    mode,
    setTheme: setThemeMode,
    toggleTheme: toggleThemeMode,
    isDark: mode === "dark",
    isLight: mode === "light",
  };
};
